import { FormGroup, Col, Form } from 'react-bootstrap'
import { Controller } from 'react-hook-form'

const CheckBox = ({
  label = '',
  name = '',
  defaultValue = undefined,
  control = {},
  onChange = () => {},
  noGrid = false,
  className = '',
  colClass = '',
  formGroupClass = 'mb-0',
  xxl = '6',
  xl = '6',
  lg = '6',
  md = '6',
  sm = '12',
  xs = '12',
}) => {
  const renderInput = () => (
    <Controller
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        // <CustomInput
        //   {...field}
        //   type='checkbox'
        //   className={`custom-control-Primary ${className}`}
        //   id={name}
        //   label={label}
        //   inline
        //   checked={field.value}
        //   onClick={onClick}
        // />

        <Form.Check // prettier-ignore
          {...field}
          type={'checkbox'}
          id={name}
          label={label}
          className={className}
          onChange={() => {
            field.onChange(!field.value)
            onChange(!field.value)
          }}
          checked={field.value}
        />
      )}
      control={control}
    />
  )

  return (
    <>
      {noGrid ? (
        renderInput()
      ) : (
        <>
          <Col
            className={colClass}
            xs={xs}
            sm={sm}
            md={md}
            lg={lg}
            xl={xl}
            xxl={xxl}
          >
            <FormGroup className={formGroupClass}>{renderInput()}</FormGroup>
          </Col>
        </>
      )}
    </>
  )
}

export default CheckBox
